export const filters = [
	[
		{
			label: '选择部门',
			type: 'select',
			attr: 'deptId',
			placeholder: '请选择',
			column:6,
			labelWidth: '96px',
		},
		{
			label: '回复人',
			type: 'select',
			attr: 'userId',
			placeholder: '请选择',
			column: 6,
			labelWidth: '96px',
		},
		{
			label: '操作时间',
			type: 'dateRange',
			valueFormat:"YYYY-MM-DD",
			attr: 'date',
			column: 8,
			labelWidth: '100px',
		},

		{
			type: 'button',
			column: 4,
		},

	],
]

export const tableColumn = [
	{
		label: '序号',
		width: '120px',
		isCustomize: true,
		tableType: 'no',
	},
	{
		label: '客户名称',
		prop: 'customerName',
        isCustomize: true,
        tableType: "name"
	},
	{
		label: '评论内容',
		prop: 'comment',
	},
	{
		label: '评论人',
		prop: 'username',
	},
	{
		label: '评论时间',
		prop: 'createTime'
	},
	{
		label: '回复内容',
		prop: 'reply',
	},
	{
		label: '回复人',
		prop: 'replyUsername',
	}
]
